import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TooltipComponent } from 'src/app/shared/components/tooltip/tooltip.component';
import { ActivityTypesEnum } from 'src/app/shared/interfaces/ActivityTypesEnum';
import { ITooltipPosition } from 'src/app/shared/interfaces/ITooltipPosition';

@Component({
  selector: 'app-discrepancy-info-with-tooltip',
  templateUrl: './discrepancy-info-with-tooltip.component.html',
  styleUrls: ['./discrepancy-info-with-tooltip.component.scss']
})
export class DiscrepancyInfoWithTooltipComponent implements OnInit {

  @Input() data: any;
  @Input() tooltipClasses: string;
  @Input() tooltipPosition: ITooltipPosition;
  @Input() tooltipWidth: number;

  @Output() removeAdjustment: EventEmitter<any> = new EventEmitter();
  
  ActivityTypesEnum = ActivityTypesEnum;
  math = Math;

  constructor() { }

  ngOnInit(): void {
  }
}
